import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: 'page-not-found', loadChildren: () => import('./page-not-found/page-not-found-routing.module').then(m => m.PageNotFoundRoutingModule) },
    { path: 'access-denied', loadChildren: () => import('./access-denied/access-denied.module').then(m => m.AccessDeniedModule) },
    { path: 'service-unavailable', loadChildren: () => import('./service-unavailable-anonymous/service-unavailable-anonymous.module').then(m => m.ServiceUnavailableAnonymousModule) },
    { path: 'network-access-guide', loadChildren: () => import('./network-access-guide/network-access-guide-anonymous.module').then(m => m.NetworkAccessGuideAnonymousModule) },
    { path: '*', loadChildren: () => import('./page-not-found/page-not-found.module').then(m => m.PageNotFoundModule) },
    {
        path: ':companyUri',
        loadChildren: () => import('./main-app/main-app.module').then(m => m.MainAppModule)
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
